// extracted by mini-css-extract-plugin
export default {"selected":"CustomerAccountTypeInput_selected__XQ42l","content":"CustomerAccountTypeInput_content__x31Is","info":"CustomerAccountTypeInput_info__+ByCP"};